import { Component, HostListener, Inject, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from 'src/app/core/services/account.service';
import { SelectedDeviceService } from 'src/app/shared/device/selected-device.service';
import { PghUserDeviceBase } from 'src/app/shared/device/pgh-user-device';
import { ADPResourceService } from 'digital-core';

@Component({
  selector: 'pgh-edit-home-device-details',
  templateUrl: './edit-home-device-details-modal.component.html',
  styles: [`::ng-deep .nickname-ip mat-hint {
    display: none;
  }`]
})
export class EditHomeDeviceDetailsModalComponent implements OnInit {
  public nickName: string;
  public nickNameResource: any;
  public deviceDetailsForm: UntypedFormGroup;
  public title: string;
  public isSaving = false;
  public selDevice: PghUserDeviceBase;
  public deviceTypeDisplayName: string = '';
  private allDevices: PghUserDeviceBase[];
  public submitButtonLabelKey: string;
  public cancelButtonLabelKey: string;

  constructor(
    private selectedDeviceService: SelectedDeviceService,
    private dialogRef: MatDialogRef<EditHomeDeviceDetailsModalComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData: any,
    private resourceService: ADPResourceService
  ) { }

  ngOnInit() {
    this.selDevice = this.selectedDeviceService.getSelectedDevice();
    this.allDevices = this.selectedDeviceService.getAllDevices();
    if (this.selDevice.nickName == null) {
      this.nickName = this.setNickname();
    }
    else {
      this.nickName = this.selDevice.nickName;
    }

    this.deviceTypeDisplayName = this.dialogData.deviceTypeDisplayName?.toUpperCase();
    this.title = this.selDevice.make + ' ' + this.selDevice.model;
    this.submitButtonLabelKey = this.dialogData.submitButtonLabel;
    this.cancelButtonLabelKey = this.dialogData.cancelButtonLabel;

    this.nickNameResource = this.getResource('Nickname');

    this.deviceDetailsForm = new UntypedFormGroup({
      nickName: new UntypedFormControl(this.nickName, [
        Validators.required,
        Validators.maxLength(this.nickNameResource.MaxValue),
        this.validateNickNameIsUnique.bind(this)
      ])
    });
  }

  onCancelClicked() {
    this.dialogRef.close({ data: 'cancel' });
  }

  onSaveClicked() {
    this.isSaving = true;
    this.nickName = this.deviceDetailsForm.get('nickName').value;
    this.selDevice.nickName = this.nickName;
    this.selectedDeviceService.setSelectedDevice(this.selDevice);
    this.dialogRef.close({ data: 'success' });
  }

  setNickname(): string {
    let count = this.allDevices.filter(x => x?.make?.toLowerCase() === this.selDevice?.make?.toLowerCase() && x?.model?.toLowerCase() === this.selDevice?.model?.toLowerCase()).length;
    return `${this.selDevice?.make ?? ''} ${this.selDevice?.model ?? ''} ${count > 0 ? count + 1 : ''}`.trim();
  }
  nicknameDuplicate = false;

  validateNickNameIsUnique(control?: UntypedFormControl) {

    const nickName = control?.value;
    if (nickName) {
      this.nicknameDuplicate = false;
      let count = this.allDevices?.filter(x => x.nickName?.toLowerCase()?.trim() === nickName?.toLowerCase()?.trim()).length;
      if (count > 0 && nickName != this.selDevice.nickName) {
        this.nicknameDuplicate = true;
        return { pattern: true };
      } else if (!nickName?.match(this.nickNameResource.ValidationRegex)) {
        // prevent non letters and numbers        
        return { pattern: true }
      } else  
        return null
    } else
      return null;
  }

  getResource(name: string, namespace = null) {
    namespace = namespace ? namespace : "DeviceDetails_Modal";
    let title = namespace + "_" + name;
    let resourceValue = this.resourceService.getViewResourceObject(title);
    return resourceValue;
  }

}
